import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import CommentsList from '../pages/ProfileComments.vue';
import ReviewsList from '../pages/ProfileReviews.vue';

import ProfileReviewItem from '../components/ProfileReviewItem.vue';
import SearchInput from '../components/SearchInput.vue';

class ProfileCommentsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }
  init() {
    // 根據容器 ID 決定使用哪個組件
    const isCommentsList = this.container === '#comments-list';
    const isReviewsList = this.container === '#reviews-list';

    if (!isCommentsList && !isReviewsList) {
      console.error('Invalid container ID for ProfilePayoutsComponent');
      return;
    }
    const RootComponent = isCommentsList ? CommentsList : ReviewsList;

    this.app = createApp(RootComponent);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('search-input', SearchInput);
    this.app.component('profile-review-item', ProfileReviewItem);

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfileCommentsComponent;